import React from 'react';
import {
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_FLOW,
  ORDER_STATUS_SHORT,
} from '../constant/order-status';

// Read-only view of where an order is in the pipeline.
const StatusStepper: React.FC<{ status?: string }> = ({ status }) => {
  if (!status) return null;
  if (status === ORDER_STATUS_CANCELLED) {
    return <div className="stepper-cancelled">This order was cancelled.</div>;
  }
  const current = ORDER_STATUS_FLOW.indexOf(status);
  // The last status is the end of the road, not a step in progress: it shows as done, with
  // its connector filled, rather than as the ring the in-between steps get.
  const finished = current === ORDER_STATUS_FLOW.length - 1;
  return (
    <div className="stepper" aria-label={`Order status: ${status}`}>
      {ORDER_STATUS_FLOW.map((step, index) => {
        let state = '';
        if (index < current || (index === current && finished)) {
          state = 'is-done';
        } else if (index === current) {
          state = 'is-now';
        }
        return (
          <div key={step} className={`step ${state}`} title={step}>
            <i className="step-dot" />
            {ORDER_STATUS_SHORT[step] || step}
          </div>
        );
      })}
    </div>
  );
};

export default StatusStepper;
